import Bookmark from './Bookmark'

export default Bookmark
// eslint-disable-next-line import/export
export * from './Bookmark'
